import React, { useCallback, useEffect, useState } from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import { moveFormatter } from "../../fomatters/BooleanFormatter";
import Crud from "../Crud";
import {
  createColorCreator,
  createColorEditor,
} from "../../editors/ColorEditor";
import { colorFormatter } from "../../fomatters/ColorFormatter";
import OfficeList from "../../offices/officeComponents/OfficeList";
import Sports from "../Sports";
import { useDataFormatterHook } from "../../../hooks/useDataFormatterHook";
import InputSelect from "../InputSelect";

/**
 * TABLE SYSTEMCOLORS
 */
function OfficeOptions() {
  const [office, setOffice] = useState();
  const onOfficeChanged = useCallback((office) => {
    setOffice(office);
  }, []);

  const { values: offices } = useDataFormatterHook({
    value: "idOffice",
    text: "officeName",
    path: `/Player/Office_GetList`,
  });

  const [sport, setSport] = useState();
  const onSportChanged = useCallback((sport) => {
    setSport(sport);
  }, []);

  const { values: sports } = useDataFormatterHook({
    value: "idSport",
    text: "sportName",
    path: `/Player/GetSports`,
  });

  useEffect(() => {
    if (offices && sports) {
      setOffice(offices[0]?.value);
      setSport(sports[0]?.value);
    }
  }, [offices, sports]);

  const lineFormatter = (value, { idSport }) => {
    switch (idSport.trim()) {
      case "ESOC":
      case "PROP":
      case "TNT":
        return "Money Line";
      case "NHL":
      case "SOC": {
        switch (value) {
          case 1:
            return "Money Line";
          case 2:
            return "Total";
          case 3:
            return "Goals";
          default:
            return value;
        }
      }
      case "MLB": {
        switch (value) {
          case 1:
            return "Money Line";
          case 2:
            return "Total";
          case 3:
            return "Run Line";
          default:
            return value;
        }
      }
      case "MU": {
        switch (value) {
          case 1:
            return "Money Line";
          case 2:
            return "Total";
          case 3:
            return "Spread";
          default:
            return value;
        }
      }
      default: {
        // CBB CFB NBA NFL
        switch (value) {
          case 1:
            return "Spread";
          case 2:
            return "Total";
          case 3:
            return "Money Line";
          default:
            return value;
        }
      }
    }
  };

  if (!sports || !offices) return <></>;
  return (
    <div className="flex flex-col gap-4 h-max">
      <div className="vertical-options">
        <InputSelect
          variant="outlined"
          size="small"
          label="Office"
          name="name"
          data={offices}
          placeholder="DataFormatter"
          setSelectValue={onOfficeChanged}
          startValue={offices?.[0]?.value}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Sport"
          name="name"
          data={sports}
          placeholder="DataFormatter"
          setSelectValue={onSportChanged}
          startValue={sports?.[0]?.value}
        />
      </div>
      <Crud
        className="unlock-overflow"
        title="Office Options"
        getUrl={() =>
          `/Addons/SystemBonusOptions_GetList?idOffice=${office}&idSport=${sport}`
        }
        getProcess={(data) =>
          data.map((item) => ({
            idComposed: `${item.idOffice}-${item.idSport}`,
            ...item,
          }))
        }
        // UPDATE
        updateUrl={() => "/Addons/SystemBonusOptions_Update"}
        updateParams={(
          { userId },
          { idOffice, idSport, line, online, onLocal }
        ) => ({
          IdOffice: idOffice,
          IdSport: idSport,
          Line: line,
          Online: JSON.parse(online),
          OnLocal: JSON.parse(onLocal),
          IdUser: Number(userId),
        })}
      >
        <TableHeaderColumn
          visible="none"
          hiddenOnInsert
          autoValue={true}
          hidden
          isKey
          dataField="idComposed"
        >
          IdComposed
        </TableHeaderColumn>
        <TableHeaderColumn
          visible="none"
          hiddenOnInsert
          autoValue={true}
          hidden
          dataField="idOffice"
        >
          IdOffice
        </TableHeaderColumn>
        <TableHeaderColumn
          visible="none"
          hiddenOnInsert
          autoValue={true}
          hidden
          dataField="idSport"
        >
          IdSport
        </TableHeaderColumn>
        <TableHeaderColumn dataField="line" dataFormat={lineFormatter}>
          Line
        </TableHeaderColumn>
        <TableHeaderColumn
          dataAlign="center"
          dataFormat={moveFormatter}
          editable={{
            type: "checkbox",
            options: {
              values: "true:false",
            },
          }}
          dataField="onLocal"
        >
          Local
        </TableHeaderColumn>
        <TableHeaderColumn
          dataAlign="center"
          dataFormat={moveFormatter}
          editable={{
            type: "checkbox",
            options: {
              values: "true:false",
            },
          }}
          dataField="online"
        >
          Online
        </TableHeaderColumn>
      </Crud>
    </div>
  );
}

export default OfficeOptions;
